import { useAuthContext } from "../AuthenticationProvider";
import { IUser } from "../../../sg-auth/models/User";

export const useLoggedInUser = (): IUser => {
    const user = useAuthContext().user;

    if (!user) {
        throw new Error("Invalid operation: cannot retrieve user when the user is not logged in");
    }

    return user;
};
